import { gql } from '@apollo/client';
import { PodcastBaseFragment } from '@/graphql/fragments/posdcast';

export const QUERY_FETCH_PODCASTS_BY_IDS = gql`
  query fetchPodcastsByIds($ids: [ID], $userId: ID) {
    podcasts(sort: "createdAt:desc", filters: { id: { in: $ids } }) {
      data {
        id
        attributes {
          ...PodcastBaseFragment
        }
      }
    }
  }
  ${PodcastBaseFragment}
`;
